// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"340814ab","455":"cd601d96"}[chunkId] + ".chunk.js";
};